import { useScrollReveal } from '@/hooks/useScrollReveal';
import { projectOverviewCards } from '@/mocks/landingData';

export default function ProjectOverview() {
  useScrollReveal('.overview-reveal', 0.1);

  return (
    <section id="overview" className="py-10 md:py-16 bg-cream">
      <div className="section-padding">
        <div className="max-w-3xl mx-auto text-center mb-8 md:mb-12">
          <div className="overview-reveal scroll-reveal">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 bg-primary/5 border border-primary/10 rounded-full font-body text-[10px] md:text-xs tracking-[0.2em] uppercase text-primary">
              <span className="w-1.5 h-1.5 bg-gold rounded-full" />
              Project Highlights
            </span>
          </div>
          <h2 className="overview-reveal scroll-reveal font-display text-2xl md:text-4xl lg:text-5xl text-charcoal font-bold mt-4 md:mt-5 leading-tight">
            Confident Auriga
          </h2>
          <p className="overview-reveal scroll-reveal font-body text-sm md:text-base text-charcoal/60 mt-3 md:mt-4 leading-relaxed max-w-2xl mx-auto">
            A premium 90-acre plotted development in Malur offering meticulously planned plots with modern infrastructure and excellent connectivity to Bangalore. Confident Auriga Malur is designed as a premium gated community with 1100+ investment plots near Bangalore, featuring a clubhouse, landscaped parks, wide internal roads, 24/7 security, and dedicated green spaces. Whether you are looking for villa plots in Malur or a strategic land investment near Bangalore, this plotted development Bangalore corridor delivers exceptional value, lifestyle, and long-term capital appreciation.
          </p>
          <p className="overview-reveal scroll-reveal font-body text-xs text-gold font-medium mt-2 tracking-wide uppercase">
            Premium Plots Near Bangalore With World-Class Amenities
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5 max-w-5xl mx-auto">
          {projectOverviewCards.map((card, index) => (
            <div
              key={card.title}
              className="overview-reveal scroll-reveal group bg-white rounded-2xl p-4 md:p-6 border border-cream-dark/50 hover:border-gold/40 transition-all duration-500 hover:-translate-y-1 hover:shadow-lg hover:shadow-gold/5 text-center"
              style={{ transitionDelay: `${index * 80}ms` }}
            >
              <div className="w-10 h-10 md:w-11 md:h-11 rounded-xl bg-primary/5 flex items-center justify-center mx-auto mb-2.5 md:mb-3 group-hover:bg-gold/10 transition-colors duration-500">
                <i className={`${card.icon} text-primary text-base md:text-lg group-hover:text-gold transition-colors duration-500`}></i>
              </div>
              <h3 className="font-display text-sm md:text-lg text-charcoal font-semibold mb-1">{card.title}</h3>
              <p className="font-body text-[11px] md:text-xs text-charcoal/60 leading-relaxed">{card.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}